import { useId } from 'react';
import TenantLogoField from './TenantLogoField';

export interface TenantBrandingValue {
  logo_url?: string | null;
  mostra_nome_tenant?: boolean;
  colore_primario?: string;
  colore_secondario?: string;
}

export default function TenantBrandingFields({ tenantId, value, onChange, onBusyChange }: {
  tenantId?: string;
  value: TenantBrandingValue;
  onChange: (changes: TenantBrandingValue) => void;
  onBusyChange?: (busy: boolean) => void;
}) {
  const id = useId();
  return <div className="space-y-5">
    <TenantLogoField tenantId={tenantId} value={value.logo_url} onChange={(logo_url) => onChange({ logo_url })} onBusyChange={onBusyChange} />
    <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
      <input type="checkbox" checked={value.mostra_nome_tenant !== false} onChange={(event) => onChange({ mostra_nome_tenant: event.target.checked })} />
      Mostra nome tenant accanto al logo
    </label>
    <p className="text-xs text-gray-500">Senza logo il nome resta visibile, per identificare il tenant.</p>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {(['colore_primario', 'colore_secondario'] as const).map((field) => {
        const label = field === 'colore_primario' ? 'Colore primario' : 'Colore secondario';
        const color = value[field] ?? (field === 'colore_primario' ? '#2563eb' : '#1e40af');
        return <div key={field}>
          <label htmlFor={`${id}-${field}`} className="mb-1 block text-sm font-medium text-gray-700">{label}</label>
          <div className="flex gap-2">
            <input aria-label={`${label}: selettore`} type="color" value={/^#[0-9a-f]{6}$/i.test(color) ? color : '#000000'} onChange={(event) => onChange({ [field]: event.target.value })} className="h-10 w-14 shrink-0 rounded border border-gray-300" />
            <input id={`${id}-${field}`} value={color} onChange={(event) => onChange({ [field]: event.target.value })} pattern="#[0-9a-fA-F]{6}" maxLength={7} required className="min-w-0 flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm" />
          </div>
        </div>;
      })}
    </div>
  </div>;
}
